module.exports = __webpack_public_path__ + "img/1D.b6b865fd.png";